import React, { useCallback, useEffect, useState } from 'react';

import { usePracticeSupportSettings } from 'lib/hooks/queries/practice/usePracticeSupportSettings';

import Icon from 'components/shared/Icon/Icon';

import PhoneSupportModal from './PhoneSupportModal';

const AssistanceCard = ({ isAdmin, practiceId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showPhoneSupport, setShowPhoneSupport] = useState(false);

  const { data: supportData } = usePracticeSupportSettings({
    params: { practiceId },
    dependencies: [practiceId],
    options: { enabled: !isAdmin && !!practiceId }
  });

  // Listen to Intercom events to keep state in sync
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.Intercom !== 'function') {
      return;
    }

    // Register callbacks for Intercom show/hide events
    window.Intercom('onShow', () => setIsOpen(true));
    window.Intercom('onHide', () => setIsOpen(false));
  }, []);

  const toggleIntercom = useCallback(() => {
    // Check if Intercom is available before trying to use it
    if (typeof window === 'undefined' || typeof window.Intercom !== 'function') {
      console.warn('Intercom is not initialized');
      return;
    }

    if (isOpen) {
      window.Intercom('hide');
    } else {
      window.Intercom('show');
    }
  }, [isOpen]);

  return (
    <div className="assistance-card flex items-center justify-between rounded-xl bg-white px-4 py-2">
      <p className="text-xs">Get assistance whenever you need it.</p>
      <div className="flex gap-2">
        {!isAdmin && (
          <Icon
            icon="call-calling-mono"
            color="primary"
            className="cursor-pointer"
            onClick={() => setShowPhoneSupport((prev) => !prev)}
          />
        )}
        {isAdmin && <Icon icon="call-calling-mono" color="primary" />}
        <Icon
          icon="intercom-mono"
          className="cursor-pointer"
          onClick={toggleIntercom}
          data-intercom-trigger="true"
        />
      </div>
      <PhoneSupportModal
        isOpen={showPhoneSupport}
        onClose={() => setShowPhoneSupport(false)}
        supportData={supportData}
      />
    </div>
  );
};

export default AssistanceCard;
